import { Typography } from '@innovamat/glimmer-components';
import type { Course } from '@innovamat/glow-api-client';

import type { ClassroomSelectedTab } from '../hooks/use-school-classrooms-data';
import { ClassroomGrid, CourseBlock } from '../school-classrooms';

import { ClassCardOptions } from '../../../components/class-card/class-card.options';
import { Classroom } from '../../../modules/classroom';
import { SchoolClassroomCard } from './school-classroom-card';

type GroupedCourses = {
  stage: string;
  courses: Course[];
};

type Props = {
  groupedCourses: GroupedCourses[];
  selectedTab?: ClassroomSelectedTab;
  isUpdatePeriod?: boolean;
  getClassroomsByCourse: (courseId: string) => Classroom[];
  createClassroomOptions: (classroom: Classroom) => ClassCardOptions;
  onNavigateToClassroom: (classroomId: string) => void;
};

export function StageClassroomsList({
  groupedCourses,
  selectedTab,
  isUpdatePeriod = false,
  getClassroomsByCourse,
  createClassroomOptions,
  onNavigateToClassroom,
}: Props): JSX.Element | null {
  const filteredGroups = groupedCourses.filter(
    (group) => group.stage === selectedTab
  );

  if (filteredGroups.length === 0) {
    return null;
  }

  return (
    <>
      {filteredGroups.map((group) =>
        group.courses.map((course) => {
          const courseClassrooms = getClassroomsByCourse(course.id);

          if (courseClassrooms.length === 0) {
            return null;
          }

          return (
            <CourseBlock key={course.id} isDisabled={isUpdatePeriod}>
              <Typography.H4>{course.name}</Typography.H4>
              <ClassroomGrid>
                {courseClassrooms.map((classroom) => (
                  <SchoolClassroomCard
                    key={classroom.id}
                    classroom={classroom}
                    isDisabled={isUpdatePeriod}
                    options={createClassroomOptions(classroom)}
                    onClick={() => onNavigateToClassroom(classroom.id)}
                  />
                ))}
              </ClassroomGrid>
            </CourseBlock>
          );
        })
      )}
    </>
  );
}
